export default __webpack_public_path__ + "static/media/clock.e838610c.svg";